import * as Ably from 'ably';
import { apiClient } from '../api/axios.js';

const FORM_HEADERS = {
  Accept: 'application/json',
  'Content-Type': 'application/x-www-form-urlencoded',
};

// Ably asks for a token on connect, shortly before each token expires and on every
// reconnect. Fetching it through apiClient (instead of authUrl + a static authHeaders copy)
// means each request carries the CURRENT moderator token - refreshed before expiry and
// retried after a 401 by apiClient's interceptors. A static copy kept the connect-time token,
// so the first renewal after that token expired was rejected and realtime dropped.
export function createAblyAuthCallback({ endpoint, clientId, sessionId }) {
  return (_tokenParams, callback) => {
    const body = new URLSearchParams({ clientId: String(clientId), sessionId: String(sessionId) });
    apiClient
      .post(endpoint, body, { headers: FORM_HEADERS })
      .then(
        (res) => (isTokenResponse(res.data)
          ? callback(null, res.data)
          : callback(toAblyAuthError({ message: 'empty token response', status: res.status }), null)),
        (err) => callback(toAblyAuthError(err), null),
      );
  };
}

// The token endpoint answers a TokenRequest / TokenDetails object or a bare token string.
function isTokenResponse(data) {
  return (typeof data === 'string' && data.trim() !== '') || (!!data && typeof data === 'object');
}

// Ably's contract (spec RSA4d): a 403 from the auth callback is fatal and moves the
// connection to FAILED; any other error leaves it DISCONNECTED and Ably retries, calling
// the callback again - with whatever token is current by then.
export function toAblyAuthError(err) {
  const status = typeof err?.status === 'number' ? err.status : undefined;
  return new Ably.ErrorInfo(`Ably token request failed: ${err?.message || 'unknown error'}`, 40170, status);
}
